import apiClient from './client';

// ─── Typen ──────────────────────────────────────────────────────────────────

export type EdgeType = 'up' | 'down' | 'partner';

export interface PathPerson {
  id: string;
  firstName: string;
  lastName: string | null;
  birthDateText: string | null;
  deathDateText: string | null;
  gender: string | null;
  profileMediaFilename: string | null;
}

export interface PathStep {
  person: PathPerson;
  edgeToNext: EdgeType | null;
  edgeLabelToNext: string | null;
}

export interface RelationshipPathResult {
  found: boolean;
  path: PathStep[];
  description: string;
}

// ─── API-Funktion ────────────────────────────────────────────────────────────

export async function findRelationshipPath(
  personAId: string,
  personBId: string,
): Promise<RelationshipPathResult> {
  const { data } = await apiClient.get<RelationshipPathResult>('/relationship-path', {
    params: { personA: personAId, personB: personBId },
  });
  return data;
}
